import {
  Mic, Camera, Music, Shield, Video, Sparkles, Star, Heart, Users, Utensils, Car, Flower, Gift, Crown, Zap, Smile,
  MapPin, Phone, Clock, Scissors, Palette, Truck, Home, Tent, Wine, Drum, Lamp, Shirt, Dog, Plus,
} from "lucide-react";

export const SERVICE_ICONS = {
  Mic, Camera, Music, Shield, Video, Sparkles, Star, Heart, Users, Utensils, Car, Flower, Gift, Crown, Zap, Smile,
  MapPin, Phone, Clock, Scissors, Palette, Truck, Home, Tent, Wine, Drum, Lamp, Shirt, Dog, Plus,
};

export const SERVICE_ICON_NAMES = Object.keys(SERVICE_ICONS);

export function ServiceIcon({ name, className = "w-7 h-7" }) {
  const Icon = SERVICE_ICONS[name] || Sparkles;
  return <Icon className={className} strokeWidth={1.5} />;
}
